export default __webpack_public_path__ + "static/media/mic.79ee7bdc.png";